import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DprActivityModelReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { SubprojectConfiguration } from '@shared/models/project-setup';

@Component({
  selector:
    'app-report-activities-with-calculated-and-or-formula-and-inline-cd',
  templateUrl:
    './report-activities-with-calculated-and-or-formula-and-inline-cd.component.html',
  styleUrls: [
    './report-activities-with-calculated-and-or-formula-and-inline-cd.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportActivitiesWithCalculatedAndOrFormulaAndInlineCdComponent {
  @Input({ required: true }) activityModel: DprActivityModelReport;
  @Input({ required: true }) calculatedCustomDataName: string;
  @Input({ required: true }) customDataFormulaName: string;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  StaticMessage = StaticMessage;
}
